import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VitaTransactionItem } from '../../../services/vita-wallet.service';

@Component({
  selector: 'app-vita-movimiento-detalle',
  templateUrl: './vita-movimiento-detalle.component.html',
  styleUrls: ['./vita-movimiento-detalle.component.sass'],
})
export class VitaMovimientoDetalleComponent {
  t: VitaTransactionItem;

  constructor(
    public dialogRef: MatDialogRef<VitaMovimientoDetalleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { tx: VitaTransactionItem },
  ) {
    this.t = data.tx;
  }

  get a() {
    return this.t.attributes;
  }

  /** Detalle de withdrawal si vino embebido. */
  get withdrawal(): any | null {
    return this.a?.included?.withdrawal ?? null;
  }

  close(): void {
    this.dialogRef.close();
  }
}
